import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from 'axios';
import Cookie from 'js-cookie';
import qs from "qs";

// 跨域认证信息 header 名
var xsrfHeaderName = 'x-auth-token';
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = xsrfHeaderName;
axios.defaults.xsrfCookieName = xsrfHeaderName;

// 认证类型
var AUTH_TYPE = {
  BEARER: 'Bearer',
  BASIC: 'basic',
  AUTH1: 'auth1',
  AUTH2: 'auth2'
};

// http method
var METHOD = {
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  PUT: 'put'
};

/**
 * axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */
function request(_x, _x2, _x3, _x4) {
  return _request.apply(this, arguments);
}
/**
 * 设置认证信息
 * @param auth {Object}
 * @param authType {AUTH_TYPE} 认证类型，默认：{AUTH_TYPE.BEARER}
 */
function _request() {
  _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, method, params, config) {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _t = method;
          _context.n = _t === METHOD.GET ? 1 : _t === METHOD.POST ? 2 : _t === METHOD.DELETE ? 3 : _t === METHOD.PUT ? 4 : 5;
          break;
        case 1:
          return _context.a(2, axios.get(url, _objectSpread({
            params: params
          }, config)));
        case 2:
          if (config) {
            if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
              params = qs.stringify(params);
            }
          }
          return _context.a(2, axios.post(url, params, config));
        case 3:
          if (config) {
            if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
              params = qs.stringify(params);
            }
          }
          return _context.a(2, axios.delete(url, params, config));
        case 4:
          if (config) {
            if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
              params = qs.stringify(params);
            }
          }
          return _context.a(2, axios.put(url, params, config));
        case 5:
          return _context.a(2, axios.get(url, _objectSpread({
            params: params
          }, config)));
        case 6:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _request.apply(this, arguments);
}
function setAuthorization(auth) {
  var authType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AUTH_TYPE.BEARER;
  switch (authType) {
    case AUTH_TYPE.BEARER:
      Cookie.set(xsrfHeaderName, auth.token, {
        expires: auth.expireAt
      });
      break;
    case AUTH_TYPE.BASIC:
    case AUTH_TYPE.AUTH1:
    case AUTH_TYPE.AUTH2:
    default:
      break;
  }
}

/**
 * 移出认证信息
 * @param authType {AUTH_TYPE} 认证类型
 */
function removeAuthorization() {
  var authType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AUTH_TYPE.BEARER;
  switch (authType) {
    case AUTH_TYPE.BEARER:
      Cookie.remove(xsrfHeaderName);
      break;
    case AUTH_TYPE.BASIC:
    case AUTH_TYPE.AUTH1:
    case AUTH_TYPE.AUTH2:
    default:
      break;
  }
}

/**
 * 检查认证信息
 * @param authType
 * @returns {boolean}
 */
function checkAuthorization() {
  var authType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AUTH_TYPE.BEARER;
  switch (authType) {
    case AUTH_TYPE.BEARER:
      if (Cookie.get(xsrfHeaderName)) {
        return true;
      }
      break;
    case AUTH_TYPE.BASIC:
    case AUTH_TYPE.AUTH1:
    case AUTH_TYPE.AUTH2:
    default:
      break;
  }
  return false;
}

/**
 * 加载 axios 拦截器
 * @param interceptors
 * @param options
 */
function loadInterceptors(interceptors, options) {
  var request = interceptors.request,
    response = interceptors.response;
  // 加载请求拦截器
  request.forEach(function (item) {
    var onFulfilled = item.onFulfilled,
      onRejected = item.onRejected;
    if (!onFulfilled || typeof onFulfilled !== 'function') {
      onFulfilled = function onFulfilled(config) {
        return config;
      };
    }
    if (!onRejected || typeof onRejected !== 'function') {
      onRejected = function onRejected(error) {
        return Promise.reject(error);
      };
    }
    axios.interceptors.request.use(function (config) {
      return onFulfilled(config, options);
    }, function (error) {
      return onRejected(error, options);
    });
  });
  // 加载响应拦截器
  response.forEach(function (item) {
    var onFulfilled = item.onFulfilled,
      onRejected = item.onRejected;
    if (!onFulfilled || typeof onFulfilled !== 'function') {
      onFulfilled = function onFulfilled(response) {
        return response;
      };
    }
    if (!onRejected || typeof onRejected !== 'function') {
      onRejected = function onRejected(error) {
        return Promise.reject(error);
      };
    }
    axios.interceptors.response.use(
    // store.state.loadding = false,
    function (response) {
      return onFulfilled(response, options);
    }, function (error) {
      return onRejected(error, options);
    });
  });
}

/**
 * 解析 url 中的参数
 * @param url
 * @returns {Object}
 */
function parseUrlParams(url) {
  var params = {};
  if (!url || url === '' || typeof url !== 'string') {
    return params;
  }
  var paramsStr = url.split('?')[1];
  if (!paramsStr) {
    return params;
  }
  var paramsArr = paramsStr.replace(/&|=/g, ' ').split(' ');
  for (var i = 0; i < paramsArr.length / 2; i++) {
    var value = paramsArr[i * 2 + 1];
    params[paramsArr[i * 2]] = value === 'true' ? true : value === 'false' ? false : value;
  }
  return params;
}
export { METHOD, AUTH_TYPE, request, setAuthorization, removeAuthorization, checkAuthorization, loadInterceptors, parseUrlParams };